import React from 'react';
export function Kontakt() {
  return <main className="max-w-[800px] mx-auto w-full px-6 py-10 flex-1" data-id="element-370">
      <h1 className="font-serif text-[2rem] font-bold text-brand-navy mb-8" data-id="element-371">
        Kontakt
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-372">
        <div data-id="element-373">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-4" data-id="element-374">
            So erreichen Sie uns
          </h2>
          <div className="font-body text-[1.1rem] leading-[1.8] text-brand-gray-600 space-y-4" data-id="element-375">
            <p data-id="element-376">
              <strong className="text-brand-navy block mb-1" data-id="element-377">Adresse</strong>
              Emerald Health Solutions Ltd.
              <br data-id="element-378" />
              Unit 12, Business Centre, Sandyford
              <br data-id="element-379" />
              Dublin 18, D18 X2P9, Ireland
            </p>
            <p data-id="element-380">
              <strong className="text-brand-navy block mb-1" data-id="element-381">Telefon</strong>
              +353 1 496 0123
            </p>
            <p data-id="element-382">
              <strong className="text-brand-navy block mb-1" data-id="element-383">E-Mail</strong>
              contact@emerald-health.ie
            </p>
          </div>
        </div>

        <div className="bg-brand-gray-100 p-6 border border-brand-gray-200" data-id="element-384">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-4" data-id="element-385">
            Schreiben Sie uns
          </h2>
          <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-386">
            <div data-id="element-387">
              <label htmlFor="name" className="block font-sans text-[0.8rem] font-medium text-brand-navy mb-1.5" data-id="element-388">
                Name
              </label>
              <input type="text" id="name" className="w-full border border-brand-gray-200 p-2.5 font-sans text-[0.9rem] focus:outline-none focus:border-brand-red transition-colors" placeholder="Ihr Name" data-id="element-389" />
            </div>
            <div data-id="element-390">
              <label htmlFor="email" className="block font-sans text-[0.8rem] font-medium text-brand-navy mb-1.5" data-id="element-391">
                E-Mail
              </label>
              <input type="email" id="email" className="w-full border border-brand-gray-200 p-2.5 font-sans text-[0.9rem] focus:outline-none focus:border-brand-red transition-colors" placeholder="ihre.email@beispiel.de" data-id="element-392" />
            </div>
            <div data-id="element-393">
              <label htmlFor="message" className="block font-sans text-[0.8rem] font-medium text-brand-navy mb-1.5" data-id="element-394">
                Nachricht
              </label>
              <textarea id="message" rows={4} className="w-full border border-brand-gray-200 p-2.5 font-sans text-[0.9rem] focus:outline-none focus:border-brand-red transition-colors resize-y" placeholder="Ihre Nachricht an uns..." data-id="element-395"></textarea>
            </div>
            <button type="submit" className="bg-brand-red text-white font-sans text-[0.85rem] font-medium tracking-[0.06em] uppercase py-3 px-6 w-full hover:bg-[#A93226] transition-colors cursor-pointer" data-id="element-396">
              Nachricht senden
            </button>
          </form>
        </div>
      </div>
    </main>;
}